import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';

@Component({
	selector: 'app-violencia',
	templateUrl: './violencia.component.html',
	styleUrls: ['./violencia.component.scss']
})
export class ViolenciaComponent implements OnInit {

	violenciaLaboralFormKey: ManagedLinkKey = ManagedLinkKey.VIOLENCIA_LABORAL_FORM;

	constructor() {
	}

	ngOnInit() {
	}

}
